import { useEffect, useState } from 'react';
import {
  Card,
  Container,
  Stack,
  Link,
  Typography,
  TextField,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  Grid,
  FormControl,
  InputLabel,
  tableCellClasses,
  TextareaAutosize,
  Autocomplete,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { FiEye } from 'react-icons/fi';
import { BiCloudDownload } from 'react-icons/bi';
import { AiFillPrinter, AiFillDelete, AiFillEye } from 'react-icons/ai';
import { Icon } from '@iconify/react';
import add from '@iconify/icons-ic/add';
import remove from '@iconify/icons-ic/sharp-minus';
import { Box } from '@mui/system';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { MdOutlineAdd } from 'react-icons/md';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import { fDate } from '../../utils/formatTime';

// API
import loginListService from '../services/loginListApplication';
import partnerService from '../services/partnerService';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const {
  LoginListApplicationSummary,
  SaveApplicationDetails,
  PartnerApplicationLoginType,
  LoginCodesList
} = loginListService;
const {
  BankList,
  LeadsSubmissionMode,
  BankBranchList,
  AddBankBranch,
  ContactPersonList,
  AddContactPerson
} = partnerService;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fafbfc'
  },
  '&:hover': {
    backgroundColor: '#f1f5f9'
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '12px 16px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#637381',
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px 16px',
    borderBottom: '1px solid #f4f6f8'
  }
}));

function SubmitLogin() {
  const navigate = useNavigate();
  const [loanInterested, setLoanInterested] = useState(' ');
  const [selectBank, setSelectBank] = useState(' ');
  const [selectMode, setSelectMode] = useState(' ');
  const [selectLoginType, setSelectLoginType] = useState(' ');
  const [selectLoginCode, setSelectLoginCode] = useState('');
  const [selectModeList, setSelectModeList] = useState([]);
  const [bankListOpt, setBankListOpt] = useState([]);
  const [applicationList, setApplicationList] = useState([]);
  const [token, setToken] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [userId, setUserId] = useState('');
  // bank name autocomplete
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [branches, setBranches] = useState([]);
  const [inputBankName, setInputBankName] = useState('');
  // Processing Center autocomplete
  const [processCenter, setProcessCenter] = useState('');
  const [processCenterId, setProcessCenterId] = useState(null);
  const [inputProcessingCenter, setInputProcessingCenter] = useState('');
  // bank contact person autocomplete
  const [contactPerson, setContactPerson] = useState([]);
  const [bankcontactPersonId, setBankcontactPersonId] = useState(null);
  const [inputContactPerson, setInputContactPerson] = useState('');
  // comment box
  const [summaryComment, setSummaryComment] = useState('');
  const [addcontPerson, setAddContPerson] = useState('');
  const [refreshComp, setRefreshComp] = useState(null);
  const [validationMsg, setValidationMsg] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const [leadId, setLeadId] = useState();
  const [loginType, setLoginType] = useState([]);
  const [loginCodesListData, setLoginCodesListData] = useState([]);
  // console.log('loginCodesListData', loginCodesListData);
  const { LoginData } = useLoginSelector();

  // close dialog box
  const handleClose = () => {
    setDialogOpen(false);
  };

  // Fired Api of Processing Center
  const handleProcessing = () => {
    (async () => {
      const credential = {
        bankId: selectedBankId.bankId,
        branchName: processCenter
      };
      const ifFiredAddBankBranch = await AddBankBranch(credential, token);
      // console.log('ifFiredAddBankBranch', ifFiredAddBankBranch);
      if (ifFiredAddBankBranch.status === 'success') {
        const ifFiredBankBranchList = await BankBranchList(
          {
            bankId: selectedBankId.bankId,
            pageSize: 100,
            pageNumber: 1,
            sortOrder: 'asc'
          },
          token
        );
        console.log('ifFiredBankBranchList', ifFiredBankBranchList);
        setBranches(ifFiredBankBranchList.data.branches);
        // setRefreshComp(new Date());
      }
    })();
  };

  // Fired Api of Branch contact person to Add person
  const handleAddBankPerson = () => {
    (async () => {
      const credential = {
        bankId: selectedBankId.bankId,
        contactPersonName: addcontPerson
      };
      const ifFiredAddContactPersonApi = await AddContactPerson(credential, token);
      // console.log('ifFiredAddContactPersonApi', ifFiredAddContactPersonApi);

      if (ifFiredAddContactPersonApi.status === 'success') {
        const credential = {
          bankId: selectedBankId.bankId,
          searchLiteral: '',
          pageSize: 100,
          pageNumber: 1,
          sortOrder: 'asc'
        };
        const ifFiredContactPersonListApi = await ContactPersonList(credential, token);
        // console.log('ifFiredContactPersonListApi', ifFiredContactPersonListApi);
        setContactPerson(ifFiredContactPersonListApi.data.contactPersons);
      }
    })();
  };

  // Fired Api to submit form of APPLICATION SUMMARY page
  const handleSubmitform = async () => {
    if (selectedBankId === null) {
      setDialogOpen(true);
      setValidationMsg('Please select bank name');
      return true;
    }
    if (selectMode === ' ') {
      setDialogOpen(true);
      setValidationMsg('Please select mode');
      return true;
    }

    if (selectLoginType === ' ') {
      setDialogOpen(true);
      setValidationMsg('Please select login type');
      return true;
    }

    // if (selectLoginCode === '') {
    //   setDialogOpen(true);
    //   setValidationMsg('Please select login code');
    //   return true;
    // }

    if (processCenterId === null) {
      setDialogOpen(true);
      setValidationMsg('Please select processing center');
      return true;
    }
    if (bankcontactPersonId === null) {
      setDialogOpen(true);
      setValidationMsg('Please select bank contact person');
      return true;
    }
    if (summaryComment === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter comments');
      return true;
    }

    const credential = {
      applicationId: applicationId,
      leadId: leadId,
      submittedToBankId: selectedBankId.bankId,
      bankContactPersonId: bankcontactPersonId.contactId,
      processionCenterTypeId: processCenterId.branchId,
      submissionModeTypeId: selectMode,
      submissionComments: summaryComment,
      bankLoginTypeId: selectLoginType,
      bankLoginCode: selectLoginCode ? selectLoginCode : null
    };

    const ifFiredSubmitApplicationApi = await SaveApplicationDetails(credential, token);
    if (ifFiredSubmitApplicationApi.status === 'success') {
      setInputBankName('');
      setSelectedBankId(null);
      setSelectMode(' ');
      setSelectLoginType(' ');
      setSelectLoginCode('');
      setLoginCodesListData([]);
      setInputProcessingCenter('');
      setProcessCenterId(null);
      setInputContactPerson('');
      setBankcontactPersonId(null);
      setSummaryComment('');
      setRefreshComp(new Date());
    }
  };

  useEffect(() => {
    const authToken = LoginData?.jwt;
    setToken(authToken);
    const companyId = LoginData?.companyId;
    setCompanyId(companyId);
    const userId = LoginData?.userId;
    setUserId(userId);
    const authLeadId = JSON.parse(localStorage.getItem('loginLeadId'));
    setLeadId(authLeadId);
    const authApplicationId = JSON.parse(localStorage.getItem('loginApplicationId'));
    setApplicationId(authApplicationId);

    (async () => {
      // Fired Api of Bank name
      const ifPreviewDataBank = await BankList(authToken);
      if (ifPreviewDataBank.status === 'success') {
        setBankListOpt(ifPreviewDataBank.data.banks);
      } else if (ifPreviewDataBank.status === 'error') {
        localStorage.clear();
        navigate('/');
      }
      // Fired Api of Mode of submission
      const ifFiredLeadsSubmissionModeAPI = await LeadsSubmissionMode(authToken);
      if (ifFiredLeadsSubmissionModeAPI.status === 'success') {
        setSelectModeList(ifFiredLeadsSubmissionModeAPI.data.leadSubmissionModes);
      }
      // Fired Api of APPLICATION SUMMARY to show the list
      const credential = {
        applicationId: authApplicationId,
        leadId: authLeadId
      };
      const ifFiredListApplication = await LoginListApplicationSummary(credential, authToken);
      // console.log('ifFiredListApplication', ListSubmittedApplication);
      if (ifFiredListApplication.status === 'success') {
        // console.log('ifFiredListApplication', ifFiredListApplication);
        setApplicationList(ifFiredListApplication.data.applicationSummary);
      }

      const PartnerApplicationLoginTypeApiResponse = await PartnerApplicationLoginType(authToken);
      // console.log('PartnerApplicationLoginTypeApiResponse', PartnerApplicationLoginTypeApiResponse);
      if (PartnerApplicationLoginTypeApiResponse.status === 'success') {
        setLoginType(PartnerApplicationLoginTypeApiResponse.data.applicationLoginTypes);
      }
    })();
  }, [refreshComp]);
  return (
    <Page title="Kpros by Kalolytic Solutions || Log In">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="APPLICATION CLOSURE DETAILS" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Box display="flex" gap={1} mb={3}>
            <Tooltip title="Application View" placement="top" arrow>
              <IconButton
                sx={{
                  border: '1px solid #eaedf1',
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  color: '#13519d',
                  '&:hover': { backgroundColor: '#f4f6f8' }
                }}
              >
                <FiEye size={18} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print" placement="top" arrow>
              <IconButton
                sx={{
                  border: '1px solid #eaedf1',
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  color: '#13519d',
                  '&:hover': { backgroundColor: '#f4f6f8' }
                }}
              >
                <AiFillPrinter size={18} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download" placement="top" arrow>
              <IconButton
                sx={{
                  border: '1px solid #eaedf1',
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  color: '#13519d',
                  '&:hover': { backgroundColor: '#f4f6f8' }
                }}
              >
                <BiCloudDownload size={18} />
              </IconButton>
            </Tooltip>
          </Box>

          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
              p: 3,
              mb: 3
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#13519d', mb: 2.5 }}>
              Fill Details
            </Typography>
            <Grid container spacing={2.5}>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                  >
                    Bank Name
                  </Typography>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo2"
                    options={bankListOpt}
                    size="small"
                    getOptionLabel={(option) => option.bankName}
                    renderOption={(props, option) => <li {...props}>{option.bankName}</li>}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Select Bank Name"
                        size="small"
                      />
                    )}
                    value={selectedBankId}
                    onChange={async (e, newValue) => {
                      setSelectLoginCode('');
                      setSelectedBankId(newValue);
                      // Fired API of Bank branch list
                      const ifFiredBankBranchList = await BankBranchList(
                        {
                          bankId: newValue.bankId,
                          pageSize: 100,
                          pageNumber: 1,
                          sortOrder: 'asc'
                        },
                        token
                      );
                      if (ifFiredBankBranchList.status === 'success') {
                        setBranches(ifFiredBankBranchList.data.branches);
                      } else {
                        setBranches([]);
                      }
                      // Fired API of Bank contact person
                      const credential = {
                        bankId: newValue.bankId,
                        searchLiteral: '',
                        pageSize: 100,
                        pageNumber: 1,
                        sortOrder: 'asc'
                      };
                      const ifFiredContactPersonListApi = await ContactPersonList(
                        credential,
                        token
                      );
                      if (ifFiredContactPersonListApi.status === 'success') {
                        setContactPerson(ifFiredContactPersonListApi.data.contactPersons);
                      } else {
                        setContactPerson([]);
                      }
                      // fire api for login code
                      const LoginCodesListApiResponse = await LoginCodesList(
                        {
                          companyId: companyId,
                          userId: userId,
                          bankId: newValue.bankId
                        },
                        token
                      );
                      if (LoginCodesListApiResponse.status === 'success') {
                        setLoginCodesListData(LoginCodesListApiResponse.data.dsaLoginCodes);
                      } else {
                        setLoginCodesListData([]);
                      }
                      setRefreshComp(new Date());
                    }}
                    inputValue={inputBankName}
                    onInputChange={(_, v) => setInputBankName(v)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                  >
                    Mode of Submission
                  </Typography>
                  <Select
                    fullWidth
                    size="small"
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectMode}`
                    }}
                    value={selectMode}
                    onChange={(e) => setSelectMode(e.target.value)}
                  >
                    <MenuItem value=" " disabled>
                      Select Mode
                    </MenuItem>
                    {selectModeList && selectModeList.length > 0
                      ? selectModeList.map((item, index) => (
                          <MenuItem value={item.typeId} key={index}>
                            {item.typeName}
                          </MenuItem>
                        ))
                      : ''}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                  >
                    Login Type
                  </Typography>
                  <Select
                    fullWidth
                    size="small"
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectLoginType}`
                    }}
                    value={selectLoginType}
                    onChange={(e) => setSelectLoginType(e.target.value)}
                  >
                    <MenuItem value=" " disabled>
                      Select Login Type
                    </MenuItem>
                    {loginType.length > 0
                      ? loginType.map((item, index) => (
                          <MenuItem key={index} value={item.typeId}>
                            {item.typeName}
                          </MenuItem>
                        ))
                      : ''}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                  >
                    Login Code
                  </Typography>
                  <Select
                    fullWidth
                    size="small"
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectLoginCode}`
                    }}
                    value={selectLoginCode}
                    onChange={(e) => setSelectLoginCode(e.target.value)}
                  >
                    {loginCodesListData && loginCodesListData.length > 0 ? (
                      loginCodesListData.map((item, index) => (
                        <MenuItem key={index} value={item.bankId}>
                          {item.bankLoginCode}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>
                        Select Login Code
                      </MenuItem>
                    )}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                  >
                    Processing Center
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Autocomplete
                      disablePortal
                      fullWidth
                      id="combo-box-demo2"
                      size="small"
                      options={branches}
                      getOptionLabel={(option) => option.branchName}
                      renderOption={(props, option) => <li {...props}>{option.branchName}</li>}
                      renderInput={(params) => (
                        <TextField
                          onChange={async (e) => {
                            setProcessCenter(e.target.value);
                          }}
                          {...params}
                          fullWidth
                          size="small"
                          placeholder="Type Processing Center"
                        />
                      )}
                      value={processCenterId}
                      onChange={(e, newValue) => {
                        setProcessCenterId(newValue);
                      }}
                      inputValue={inputProcessingCenter}
                      onInputChange={(_, v) => setInputProcessingCenter(v)}
                    />
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        sx={{
                          color: '#13519d',
                          backgroundColor: 'rgba(19, 81, 157, 0.08)',
                          borderRadius: '8px',
                          p: 1,
                          '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
                        }}
                        onClick={(e) => handleProcessing()}
                      >
                        <MdOutlineAdd size={18} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                  >
                    Bank Contact Person
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Autocomplete
                      disablePortal
                      fullWidth
                      id="combo-box-demo2"
                      options={contactPerson}
                      size="small"
                      getOptionLabel={(option) => option.contactPersonName}
                      renderOption={(props, option) => (
                        <li {...props}>{option.contactPersonName}</li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          onChange={(e) => setAddContPerson(e.target.value)}
                          {...params}
                          fullWidth
                          size="small"
                          placeholder="Type Bank Contact Person"
                        />
                      )}
                      value={bankcontactPersonId}
                      onChange={(e, newValue) => {
                        setBankcontactPersonId(newValue);
                      }}
                      inputValue={inputContactPerson}
                      onInputChange={(_, v) => setInputContactPerson(v)}
                    />
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        sx={{
                          color: '#13519d',
                          backgroundColor: 'rgba(19, 81, 157, 0.08)',
                          borderRadius: '8px',
                          p: 1,
                          '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
                        }}
                        onClick={(e) => handleAddBankPerson()}
                      >
                        <MdOutlineAdd size={18} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                  >
                    Comments
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{ className: 'textInput' }}
                    placeholder="Comments"
                    multiline
                    rows={3}
                    value={summaryComment}
                    onChange={(e) => setSummaryComment(e.target.value)}
                  />
                </Box>
              </Grid>
            </Grid>
          </Card>

          <Box textAlign="right" mb={3}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#13519d',
                borderRadius: '8px',
                px: 4,
                py: 1,
                fontWeight: 600,
                '&:hover': { backgroundColor: '#0d3b75' }
              }}
              onClick={(e) => handleSubmitform()}
            >
              Submit
            </Button>
          </Box>

          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
              overflow: 'hidden',
              mb: 3
            }}
          >
            <Box px={3} pt={2.5} pb={1.5}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#13519d' }}>
                Summary
              </Typography>
            </Box>
            <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Bank Name</StyledTableCell>
                    <StyledTableCell align="left">Mode of Submission</StyledTableCell>
                    <StyledTableCell align="left">Processing Center</StyledTableCell>
                    <StyledTableCell align="left">Contact Person Name</StyledTableCell>
                    <StyledTableCell align="left">Comments</StyledTableCell>
                    <StyledTableCell align="left">Submitted On</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {applicationList.map((item, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell sx={{ fontWeight: 600 }}>
                        {item.bankEntity ? item.bankEntity.bankName : 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell sx={{ color: '#637381' }}>
                        {item.submissionMode ? item.submissionMode.typeName : 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell sx={{ color: '#637381' }}>
                        {item.branch ? item.branch.branchName : 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell sx={{ color: '#637381' }}>
                        {item.contactPerson ? item.contactPerson.contactPersonName : 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell sx={{ color: '#637381' }}>
                        {item.submissionComments ? item.submissionComments : 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell sx={{ color: '#637381' }}>
                        {item.submissionDate ? fDate(item.submissionDate) : 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell align="center" width={100}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 0.5,
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <Tooltip title="Delete" placement="top" arrow>
                            <IconButton
                              sx={{
                                color: '#d32f2f',
                                padding: '4px',
                                '&:hover': {
                                  backgroundColor: 'rgba(211, 47, 47, 0.08)'
                                }
                              }}
                            >
                              <AiFillDelete size={18} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="View" placement="top" arrow>
                            <IconButton
                              sx={{
                                color: '#13519d',
                                padding: '4px',
                                '&:hover': {
                                  backgroundColor: 'rgba(19, 81, 157, 0.08)'
                                }
                              }}
                            >
                              <AiFillEye size={18} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>

          <Dialog
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: { borderRadius: '16px', overflow: 'hidden' }
            }}
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">{validationMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} sx={{ color: '#13519d', fontWeight: 600 }}>
                Retry
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
}
export default SubmitLogin;

// Top Banks
const topBanks = [
  { label: 'Axis Bank' },
  { label: 'HDFC Bank' },
  { label: 'HDFC Ltd.' },
  { label: 'ICICI Bank' },
  { label: 'PNB Housing' },
  { label: 'Piramal Housing' },
  { label: 'Standard Chartered Bank' },
  { label: 'Yes Bank' },
  { label: 'Aditya Birla Housing Finance' },
  { label: 'IDFC Bank' },
  { label: 'RBL Bank' },
  { label: 'Federal Bank' },
  { label: 'Fedfina' },
  { label: 'HDB Financial' },
  { label: 'IIFL Finance' },
  { label: 'Tata Capital' },
  { label: 'ICICI Home Finance' },
  { label: 'Cholamandalam Finance' },
  { label: 'L&T Finance' },
  { label: 'Karur Vysya Bank' },
  { label: 'Hero Housing Finance' },
  { label: 'Kotak Mahindra Bank' },
  { label: 'Fullerton Grihashakti' },
  { label: 'Anand Rathi Financial' },
  { label: 'Aadhar Housing Finance' },
  { label: 'Godrej Housing Finance' },
  { label: 'Deutsche Bank' },
  { label: 'Jana Small Finance Bank' },
  { label: 'HSBC Bank' },
  { label: 'DCB Bank' },
  { label: 'Bank of Baroda' },
  { label: 'Bajaj Housing Finance' },
  { label: 'LIC Housing Finance' },
  { label: 'AU Small Finance Bank' },
  { label: 'Union Bank of India' },
  { label: 'State Bank of India' }
];
